import { graphql, useStaticQuery } from 'gatsby';

export default class Events {
  constructor(_data = {}, _events = []) {
    this.events = _events;
    this.data = _data;
  }

  query(type = 'en') {
    this.data = useStaticQuery(graphql`
      query {
        umbraco {
          allEventAr: allEvent(culture: "ar") {
            items {
              id
              title
              startDate
              endDate
              eventSectors
              eventType
              eventAudiences
              eventVenues
              featuredImage {
                url
              }
              url
            }
          }
          allEvent {
            items {
              id
              title
              startDate
              endDate
              eventSectors
              eventType
              eventAudiences
              eventVenues
              featuredImage {
                url
              }
              url
            }
          }
        }
      }
    `);
    if (type === 'ar') {
      this.events = this.data.umbraco.allEventAr.items;
    } else {
      this.events = this.data.umbraco.allEvent.items;
    }
  }

  get(type) {
    this.query(type);
    return this.events;
  }
}
